export default __webpack_public_path__ + "static/media/approved-icon-g.d751ef20.svg";